import { FormattedMessage } from 'react-intl';
import { useModal } from 'mui-modal-provider';

import { Button } from '../../../../common/button-new';
import { ConsultationButtonProps } from './consultation-button.models';
import { ConsultationModal } from '../consultation-modal';
import { ensureAbsoluteUrl } from '../../../../../utils';

export const ConsultationButton = ({ phone, website }: ConsultationButtonProps): JSX.Element => {
  const { showModal } = useModal();
  const handleClick = (): void => {
    showModal(ConsultationModal,  { phone });
  };

  return (
    <>{website ? (
      <Button
        testId="consultation-link"
        style="darker"
        to={ensureAbsoluteUrl(website)}
        target="_blank"
      >
        <FormattedMessage id="ecp.cataract.button" />
      </Button>
    ) : (
      <Button
        testId="consultation-button"
        style="darker"
        onClick={handleClick}
      >
        <FormattedMessage id="ecp.cataract.button" />
      </Button>
    )}</>
  );
};
